import Reflux from 'reflux';
import readOnlyHelper from 'flux/helpers/readOnlyHelper';

const readOnlyCfg = readOnlyHelper.modalActionConfigFactory();

export default Reflux.createActions({
  show: readOnlyCfg,
  hide: {},
});
